module.exports = __webpack_public_path__ + "static/media/play2.5a53be22.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/play2.svg
// module id = 618
// module chunks = 0